import styled from 'styled-components'

export const RegionHolder = styled.div<{ $isVisible: boolean }>`
  background: ${({ theme }) => theme.webMktPalette.background.gray};

  ${({ $isVisible }: any) => {
    if ($isVisible) {
      return `
        display: block;
      `
    } else {
      return `
        display: none;
      `
    }
  }}
`

export const TitleHolder = styled.div`
  display: flex;
  margin-top: 64px;
  margin-bottom: 64px;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    margin-bottom: 48px;
  }
`

export const AllOfficeHolder = styled.div`
  display: flex;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    flex-direction: column;
  }
`

export const OfficeColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  &:nth-child(odd) {
    margin-right: 24px;
  }
`
